import { CalendarState } from 'types/calendar';

export const calendarInitialState: CalendarState = {
  locale: '',
  lateCancellationNoShowPayment: {
    askForPaymentModalIsOpen: false,
    paymentModalIsOpen: false,
  },
};
